<template>
    <v-app dark style="
    background: #030303;
    background: -webkit-linear-gradient(to right, #030303, #090909);
    background: linear-gradient(to right, #030303, #090909);
  ">
    <div id="app">
      <div id="nav">
        <Navbar/>
      </div>
      <router-view> </router-view>
    </div>
  </v-app>
</template>

<style scoped>
a {
    color: #a50e06;
}
a#maintextlink {
  color: #a50e06;
}
</style>

<script>

  import Navbar from '@/components/Navbar.vue'

  export default {
    components: {
      Navbar,
    }
  }


</script>
